import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../../../services/login-service';
import { OpenGrid } from '../../../components/wc-grid/wc-grid-popup/wc-grid-popup.component';
import { EditDialogService } from '../../../utility/dialog/edit-dialog-service';
import { GridApiService } from '../../../components/wc-grid/services/grid-api.service';
import { SortDef } from '../../../components/wc-grid/grid-types';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'ws-welcomepage',
  standalone: false,
  templateUrl: './ws-welcome.component.html',
  styleUrls: ['./ws-welcome.component.css']
})
export class WaterSharingWelcomeComponent {
  mobileMenuOpen = false;
  context: 'Share' | 'Trade' = 'Share';
  currentView: string | null = null;
  currentFormSharing: 'Have' | 'Need' | null = null;
  currentFormTrading: 'Have' | 'Need' | null = null;
  currentForm: 'Have' | 'Need' | null = null;

  dashboardType: 'Share' | 'Trade' | 'Admin' = 'Share';
  isAdminDashboard = false;
  activeTab: string | null = null;
  selectedClientRoles: string[] = [];
  sort: SortDef[] = [];
  private clientAquatradeEnabled = false;
  private clientAquashareEnabled = false;
  private userAquatradeEnabled = false;
  private userAquashareEnabled = false;
  isAquatradeEnabled$ = new BehaviorSubject<boolean>(false);
  isAquashareEnabled$ = new BehaviorSubject<boolean>(false);

  constructor(private router: Router, public loginService: LoginService, private dialogService: EditDialogService, private api: GridApiService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.loadAquatradeClientFlags();
    this.loadAquatradeUserFlags()
  }

  
  goBack() {
    this.router.navigate(['/']); 
  }

  openView(view: string, resetForm: boolean = false): void {
    const previousContext = this.context;
    this.activeTab = view;
    switch (view) {

      case 'sharingDashboard':
        this.context = 'Share';
        this.dashboardType = 'Share';
        this.loadDashboardSafely();
        break;

      case 'tradingDashboard':
        this.context = 'Trade';
        this.dashboardType = 'Trade';
        this.loadDashboardSafely();
        break;

      case 'waterSharing':
        this.context = 'Share';
        this.currentView = 'waterSharing';
        break;

      case 'AdminDashboard':
        //this.currentView = null;        
        this.dashboardType = 'Admin';   
        this.loadDashboardSafely();     
        break;

      case 'waterTrading':
        this.context = 'Trade';
        this.currentView = 'waterTrading';
        break;

      case 'shareStats':
      case 'tradeStats':
        this.currentView = view;
        break;

      default:
        this.currentView = view;
        break;
    }
    if (resetForm) {
      this.resetForms(previousContext);
    } else {
      this.restoreCurrentForm();
    }
  }

  private loadDashboardSafely(): void {
    this.currentView = null;

    setTimeout(() => {
      this.currentView = 'dashboard';
    }, 0);
  }

  private resetForms(previousContext: 'Share' | 'Trade'): void {
    if (previousContext === 'Share') {
      this.currentFormSharing = null;
    } else {
      this.currentFormTrading = null;
    }

    this.currentForm = null;
  }

  private restoreCurrentForm(): void {
    this.currentForm =
      this.context === 'Share'
        ? this.currentFormSharing
        : this.currentFormTrading;
  }


  onFormChange(form: 'Have' | 'Need' | null) {
    this.currentForm = form;

    if (this.context === 'Share') {
      this.currentFormSharing = form;
    } else {
      this.currentFormTrading = form;
    }
  }

  manageAquatradeClients() {
    const dialogRef = OpenGrid("aquatradeClientMgmt", this.dialogService);
    dialogRef.afterClosed().subscribe(() => {
      this.loadAquatradeClientFlags(); 
    });
  }

  manageAquatradeUsers() {
    const dialogRef = OpenGrid("aquatradeUserMgmt", this.dialogService, 1700, 850, true);
    dialogRef.afterClosed().subscribe(() => {
      this.loadAquatradeUserFlags();
    });
  }
  get workingClientId(): string | undefined {
    return (
      this.loginService.userOptional?.selectedClientId ??
      this.loginService.userOptional?.defaultClientId
    );
  }

  loadAquatradeClientFlags() {
    if (!this.api) return;

    this.api.data('aquatradeClientMgmt', {
      page: 1,
      pageSize: 100,
      sort: this.sort,
      filter: null,
      context: undefined
    }, (res: any) => {
      this.updateFlagsForCurrentClient(res.rows);
    });
  }
  // Update flags for the current client only
  updateFlagsForCurrentClient(rows: any[]) {
    const clientId = this.loginService.userOptional?.selectedClientId
      ?? this.loginService.userOptional?.defaultClientId;

    if (!clientId) {
      this.clientAquatradeEnabled = false;
      this.clientAquashareEnabled = false;
      this.recalculateFinalFlags();
      return;
    }

    if (rows) {
      const clientRow = rows.find(row => row.ClientId === clientId);

      if (!clientRow) {
        this.clientAquatradeEnabled = false;
        this.clientAquashareEnabled = false;
        this.recalculateFinalFlags();
        return;
      }

      this.clientAquatradeEnabled = !!clientRow.AquatradeEnabled;
      this.clientAquashareEnabled = !!clientRow.AquashareEnabled;
    }

    this.recalculateFinalFlags();
  }
 
  loadAquatradeUserFlags() {

    if (!this.api) return;

    const userName = this.loginService.userOptional?.userName;
    if (!userName) return;

    this.api.data('aquatradeUserMgmt', {
      page: 1,
      pageSize: 100,
      sort: this.sort,
      filter: null,
      context: undefined
    }, (res: any) => {

      this.updateFlagsForCurrentUser(res.rows, userName);
    });
  }

  updateFlagsForCurrentUser(rows: any[], userName: string) {

    if (rows) {
      const userRow = rows.find(row => row.Email === userName);

      if (!userRow) {

        this.userAquatradeEnabled = false;
        this.userAquashareEnabled = false;

        this.recalculateFinalFlags();
        return;
      }

      this.userAquatradeEnabled = !!userRow.AquatradeEnabled;
      this.userAquashareEnabled = !!userRow.AquashareEnabled

      this.recalculateFinalFlags();
    }
  }

  private recalculateFinalFlags() {
    const isAdmin = this.loginService.userOptional?.isGlobalAdmin
      || this.loginService.userOptional?.isCompanyAdmin;

    const finalAquatrade = isAdmin
      ? (this.loginService.userOptional?.enableAquatrade ?? false)
      : (this.clientAquatradeEnabled && this.userAquatradeEnabled);

    const finalAquashare = isAdmin
      ? (this.loginService.userOptional?.enableAquashare ?? false)
      : (this.clientAquashareEnabled && this.userAquashareEnabled);

    this.isAquatradeEnabled$.next(finalAquatrade);
    this.isAquashareEnabled$.next(finalAquashare);

    this.cdr.detectChanges();
  }

  showWaterSharingButton(): boolean {
    return this.isAquashareEnabled$.getValue();
  }

  showWaterTradingButton(): boolean {
    return this.isAquatradeEnabled$.getValue();
  }
}
